<template>
  <div class="cp-dialog">
    <myMask></myMask>
    <div class="cp-dialog__content">
        <i v-if="closeButton" class="cp-dialog__close" @click.stop="closeModal"></i>
        <div v-if="title" class="cp-dialog__title">{{ title }}</div>
        <slot></slot>
        <div v-if="buttonText" class="cp-dialog__footer">
            <div class="cp-dialog__button" @click="clickButton">{{ buttonText }}</div>
        </div>
    </div>
  </div>
</template>

<script>
import myMask from './common/mask.vue'
export default {
    props: {
        title: {
            type: String,
            default: ''
        },

        buttonText: {
            type: String,
            default: ''
        },

        closeButton: {
            type: Boolean,
            default: true
        }
    },
    components: {
        myMask
    },

    methods: {
        closeModal() {
            this.$emit('close')
        },

        clickButton () {
            this.$emit('click')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/function';
@import '../scss/components';
.cp-dialog {

    &__content {
        position: fixed;
        top: topx(150rem);
        left: 50%;
        transform: translate(-50%, 0%);
        width: topx(600rem);
        padding: topx(40rem) topx(30rem) topx(30rem);
        background: #ffffff;
        border-radius: topx(26rem);
        z-index: 11;
        box-sizing: border-box;

        .cp-dialog__title {
            margin-bottom: topx(30rem);
            text-align: center;
            color: #333333;
            font-size: topx(38rem);
        }

        .cp-dialog__footer {
            margin-top: topx(30rem);
            display: flex;
            justify-content: center;

            .cp-dialog__button {
                width: topx(360rem);
                height: topx(88rem);
                border-radius: topx(16rem);
                background: linear-gradient(180deg, #FFE636 0%, #FFD63B 100%);
                color: #613E1F;
                font-size: topx(32rem);
                text-align: center;
                line-height: topx(88rem);
            }
        }
    }

    .cp-dialog__close {
        position: absolute;
        top: topx(-68rem);
        right: 0;
        width: topx(48rem);
        height: topx(48rem);
        border: topx(2rem) solid #fff;
        border-radius: 50%;

        &::before,
        &::after {
            position: absolute;
            content: ' ';
            background-color: #fff;
            width: topx(2rem);
            left: topx(24rem);
            top: topx(8rem);
            height: topx(32rem);
        }

        &::before {
            transform: rotate(45deg);
        }

        &::after {
            transform: rotate(-45deg);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/cp-dialog.vue